export const AddAssistantTypeFormData = [
    {
        label: "Agent Type",
        name: "assistantType",
        rules: [
            {
                required: true,
                message: 'Please Input Agent Type!',
            },
        ]
    }
];